module.exports = __webpack_public_path__ + "static/media/DqEveryChildNationTurkeyThumb.b804d73c.jpg";